import { render } from "./IconBold.vue?vue&type=template&id=4e716c14"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconBold.vue"]])

export default __exports__